import { useTranslation } from "react-i18next";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full flex flex-col md:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="w-full md:w-1/2 relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20logistics%20center%20with%20organized%20product%20packaging%20area%20and%20shipping%20boxes%20soft%20warm%20lighting%20clean%20professional%20environment%20editorial%20style%20with%20cream%20and%20beige%20tones&width=960&height=800&seq=cta-left-bg&orientation=portrait"
          alt="Kaspreadsheet"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="relative z-10 flex flex-col justify-end h-full p-8 md:p-12">
          <p className="text-xs md:text-sm font-medium text-white/70 mb-4">
            {t("cta_section_label")}
          </p>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-[0.95]">
            <span className="block">{t("cta_title_line1")}</span>
            <span className="block text-xl md:text-3xl lg:text-4xl mt-1">{t("cta_title_line2")}</span>
            <span className="block text-lg md:text-2xl lg:text-2xl mt-1 text-white/80">{t("cta_title_line3")}</span>
          </h2>
        </div>
      </div>

      <div className="w-full md:w-1/2 bg-background-50 flex flex-col items-center justify-center p-8 md:p-12 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-6">
          {t("cta_right_title_line1")}<br />
          {t("cta_right_title_line2")}
        </h2>
        <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-md mb-8">
          {t("cta_right_desc")}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {t("nav_buy_now")}
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}